import {DeduplicationRecord} from './PostHogTypes'

const DEDUP_STORAGE_KEY = 'posthog_deduplication'
const MAX_ENTRIES_PER_EVENT = 500

const DeduplicationStore = {
  has(eventName: string, dedupKey: string): boolean {
    try {
      const raw = localStorage.getItem(DEDUP_STORAGE_KEY)
      if (!raw) return false
      const record: DeduplicationRecord = JSON.parse(raw)
      return Array.isArray(record[eventName]) && record[eventName].includes(dedupKey)
    } catch {
      return false
    }
  },

  add(eventName: string, dedupKey: string): void {
    try {
      const raw = localStorage.getItem(DEDUP_STORAGE_KEY)
      const record: DeduplicationRecord = raw ? JSON.parse(raw) : {}
      if (!Array.isArray(record[eventName])) {
        record[eventName] = []
      }
      record[eventName].push(dedupKey)
      if (record[eventName].length > MAX_ENTRIES_PER_EVENT) {
        record[eventName] = record[eventName].slice(-MAX_ENTRIES_PER_EVENT)
      }
      localStorage.setItem(DEDUP_STORAGE_KEY, JSON.stringify(record))
    } catch {
      // Silently fail if localStorage is full or unavailable
    }
  },

  clear(): void {
    localStorage.removeItem(DEDUP_STORAGE_KEY)
  },
}

export default DeduplicationStore
